import { isPrimitive } from "./isPrimitive";

export function deepEqual(obj1: any, obj2: any): boolean {
  if (obj1 === obj2) return true; // Same reference

  if (!obj1 || !obj2) return false;

  if (isPrimitive(obj1) && isPrimitive(obj2)) {
    return obj1 === obj2;
  }

  // Handle Arrays separately
  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    if (obj1.length !== obj2.length) return false;
    return obj1.every((item, index) => deepEqual(item, obj2[index]));
  }

  // If one is array and other is not, they are different
  if (Array.isArray(obj1) || Array.isArray(obj2)) return false;

  // Compare object keys
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  return keys1.every((key) => key in obj2 && deepEqual(obj1[key], obj2[key]));
}
